import { Box, Flex, HStack, Image, Link, Spacer, Text } from '@chakra-ui/react'
import { AppContainer } from 'components/ui/appContainer'
import { NewsListItem } from 'components/ui/newsListItem'
import { SearchHotelForm } from 'components/ui/searchHotelForm'
import { NextLink } from 'components/wrapper/nextLink'
import { useTopQuery } from 'generated/graphql'
import { SearchHotelFormInput } from 'helper/searchHotelParams'
import { useShowErrorMessageIfNeed } from 'hooks/useShowErrorMessageIfNeed'
import { SearchHotelQuery } from 'lib/query/searchHotelQuery'
import { useRouter } from 'next/router'
import { FC, useCallback, useState } from 'react'
import { Routes } from 'routes'
import { TopCampaignFacilitySection } from './topCampaignFacilitySection'
import { TopMySpotSection } from './topMySpotSection'
import { TopSectionHeader } from './topSectionHeader'

export const TopPage: FC = () => {
  const router = useRouter()
  const [searching, setSearching] = useState(false)

  const { data, loading, error, refetch } = useTopQuery({ variables: { newsPagination: { limit: 5 } } })
  useShowErrorMessageIfNeed(error)

  const onSubmit = useCallback(async (data: SearchHotelFormInput) => {
    setSearching(true)
    router.push({
      pathname: Routes.searchHotels(),
      query: SearchHotelQuery.build({ ...data, sortField: 'recommend', sortDirection: 'desc' }),
    })
  }, [])

  return (
    <>
      <AppContainer>
        <Box py={12}>
          <SearchHotelForm onSubmit={onSubmit} submitting={searching} />
        </Box>

        {data && data?.newsList.nodes.length > 0 && (
          <>
            <Spacer mt="100px" />
            <TopSectionHeader title="お知らせ" />

            <Spacer mt="8" />
            <Box borderColor="gray.100" borderWidth={1} rounded={20} px={8} py={4}>
              {data.newsList.nodes.map(news => (
                <NewsListItem key={news.id} news={news} />
              ))}
            </Box>
            <Flex direction="column" align="flex-end" mt={5}>
              <Link as={NextLink} href={Routes.news()}>
                <HStack spacing={2}>
                  <Image src="/assets/arrow_right_circle.svg" boxSize={4} />
                  <Text lineHeight={1}>過去のお知らせをすべて見る</Text>
                </HStack>
              </Link>
            </Flex>
          </>
        )}

        <Spacer mt="64px" />
        <TopMySpotSection mySpots={data?.mySpots} loading={loading} error={Boolean(error)} refetch={refetch} />

        <Spacer mt="64px" />
        <Box pb="120px">
          <TopCampaignFacilitySection
            campaignFacilities={data?.campaignFacilities}
            loading={loading}
            error={Boolean(error)}
            refetch={refetch}
          />
        </Box>
      </AppContainer>
    </>
  )
}
